import * as React from 'react';
import styled, { keyframes } from 'styled-components';

const loadAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

interface IDotLoaderProps {
  height?: number;
  width?: number;
  color?: string;
}

const LoaderWrapper = styled.div`
  border-radius: 50%;
  width: ${(props: IDotLoaderProps) => props.width}px;
  height: ${(props: IDotLoaderProps) => props.height}px;
  &:after {
    border-radius: 50%;
    width: ${(props: IDotLoaderProps) => props.width}px;
    height: ${(props: IDotLoaderProps) => props.height}px;
  }
`;

const Loader = styled.div`
  border-radius: 50%;
  width: ${(props: IDotLoaderProps) => props.width}px;
  height: ${(props: IDotLoaderProps) => props.height}px;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 1.1em solid rgba(5,5,5, 0.2);
  border-right: 1.1em solid rgba(5,5,5, 0.2);
  border-bottom: 1.1em solid rgba(5,5,5, 0.2);
  border-left: 1.1em solid ${(props: IDotLoaderProps) => props.color};
  transform: translateZ(0);
  animation: ${loadAnimation} 1.1s infinite linear;
`;
export const SimpleSpinner = (props: { height: number; width: number; color: string; style?: React.CSSProperties;  }) => {
  return (
    <LoaderWrapper
      width={props.width}
      height={props.height}
      style={props.style}
    >
      <Loader
        width={props.width}
        height={props.height}
        color={props.color}
      />
    </LoaderWrapper>
  );
};